import AiAgent, {AiAgentAccess} from "../../../../../core/model2/ai-agent/ai-agent"
import {DEFAULT_AGENT_LABEL} from "../../../../ai-chat/@const"

export const DEFAULT_AGENT_ID    : ID     = 'default-agent'
export const DEFAULT_AGENT_COLOR : number = 20    // 'Blue' from PROJECT_COLOR_OPTIONS
export const DEFAULT_AGENT_ICON  : string = 'ai-default'

export function buildDefaultAgent(): AiAgent {
    return new AiAgent({
        id           : DEFAULT_AGENT_ID,
        name         : DEFAULT_AGENT_LABEL,
        description  : 'Built-in GoodDay AI assistant.',
        instructions : '',
        access       : AiAgentAccess.COMPANY,
        metadata     : {icon: DEFAULT_AGENT_ICON, color: DEFAULT_AGENT_COLOR},
        isDeleted    : false,
    })
}
